export const selectUser = state => state.auth.user;
export const selectToken = state => state.auth.token;
export const selectIsLoggedIn = state => state.auth.isLoggedIn;
export const selectError = state => state.auth.error;

export const selectIsRefreshing = state => state.auth.isRefreshing;
export const selectUserInfo = state => state.auth.user